/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { useLayoutEffect, useCallback } from "react";

export const useOutsideClick = (
  ref: any,
  callback: (e: any) => void,
  exceptIds?: string | string[]
) => {
  // checks if clicked target element is within ref.current DOM element
  const handleClick = useCallback(
    (event: any) => {
      let skip = false;

      if (exceptIds) {
        const clickedTarget = event.target as any;
        const clickedTargetId = clickedTarget?.id || "";

        if (Array.isArray(exceptIds)) {
          exceptIds.forEach((id) => {
            if (clickedTargetId === id) skip = true;
          });
        }
        if (!Array.isArray(exceptIds) && clickedTargetId === exceptIds) {
          skip = true;
        }
      }
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        skip === false
      ) {
        callback(event);
      }
    },
    [callback, exceptIds, ref]
  );

  useLayoutEffect(() => {
    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, [callback, exceptIds, ref, handleClick]);

  return ref;
};
